import { combineReducers } from "redux";

import siteMenu from '../reducers/siteMenu';

export default combineReducers({
    siteMenu
});